import React from 'react'
import store from '../store/Store'
import routes from '../routes/Routes'

import Editor from '../components/editor/Editor'

import { Redirect } from "react-router-dom";

import './editorView.scss';

type editorViewState = {
	
}

type editorViewProps = {
	
}

class EditorView extends React.Component<editorViewState, editorViewProps> {

	constructor(props) {
		super(props)

		this.state = {
			
		}
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				
			})
		})
	}

	componentWillUnmount() {
		store.subscribe(() => {
			this.setState({
				
			})
		})
	}

	render() {
	  return (
	    <div className="EditorView">

	    	{
	    		store.getState().login.loggedIn && store.getState().route.currentRoute === routes.ROUTE_ROOT ? (
	    			<Editor />
				) : store.getState().route.currentRoute === '/editorTemplate' ? (
					<Redirect to='/editorTemplate' />
				) : (
	    			<Redirect to={ routes.ROUTE_LOGIN } />
	    		)
	    	}

	    </div>
	  )
	}
}

export default EditorView;